import React from 'react';
import { Box, Avatar, useMediaQuery, useTheme } from '@mui/material';

const BookingAvatar: React.FC<{ profilePicture: string; clientName: string }> = ({
  profilePicture,
  clientName,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box flex={0.1} display="flex" justifyContent="center">
      <Avatar
        src={profilePicture}
        alt={clientName}
        sx={{
          width: isSmallScreen ? 40 : 56,
          height: isSmallScreen ? 40 : 56,
          marginTop: '2px',
        }}
      >
        {clientName.toUpperCase()}
      </Avatar>
    </Box>
  );
};

export default BookingAvatar;
